import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', alias: ['/login'], name: 'login', component: () => import('@/components/Login') },
    { path: '/error', component: () => import('@/components/PageNotFound') },
    {
      path: '/',
      name: 'main',
      component: () => import('@/components/Main'),
      children: [
        {
          path: 'home',
          component: () => import('@/components/page/Home')
        },
        {
          path: 'gradestatus',
          component: () => import('@/components/page/GradeStatus')
        },
        {
					path: 'gradestatustrend',
					component: () => import('@/components/page/GradeStatusTrend')
        },
        {
					path: 'batterystatus',
					component: () => import('@/components/page/BatteryStatus')
        },
        {
					path: 'driverpattern',
					component: () => import('@/components/page/DriverPattern')
        }
      ]
    },
    { path: '/get_car_info', component: () => import('@/components/page/get_car_info') },
    { path: '/get_route_path', component: () => import('@/components/page/get_route_path') },
    { path: '/get_route_line', component: () => import('@/components/page/get_route_line') },
    { path: '/get_otoplug', component: () => import('@/components/page/get_otoplug'), name: 'get_otoplug' },
    { path: '*', redirect: '/error' }
  ]
})

export default router
